<mat-card class="p-0 fx-flex-100 h-100">
  <div class="p-16 fx-row align-items-center justify-content-between">
    <span class="text bold">{{'CASE.USERS_TITLE' | translate}}</span>
    <button class="main-button ml-10" (click)="inviteCaseOperator()" aclBasedElement resource="CASE" [scopes]="['U']">
      <div class="fx-row align-items-center justify-content-center">
        <mat-icon class="white mr-5" fontSet="material-icons-outlined">person_add</mat-icon>
        {{'CASE.INVITE_CASE_OPERATOR' | translate}}
      </div>
    </button>
  </div>
  <mat-divider></mat-divider>
  <table mat-table [dataSource]="users.docs" style="z-index: 0;" matSort (matSortChange)="onSortChange($event)">
    <ng-container matColumnDef="avatar">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span class=" small light bold">
        </span>
      </th>
      <td mat-cell *matCellDef="let user">
        <div class="fx-row align-items-center justify-content-start">
          <app-avatar [user]="user" [size]="30"></app-avatar>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span class=" small light bold">
          {{'USER.LASTNAME' | translate}}
        </span>
      </th>
      <td mat-cell *matCellDef="let user">
        <span class="text">{{user.lastName}}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span class=" small light bold">
          {{'USER.FIRSTNAME' | translate}}
        </span>
      </th>
      <td mat-cell *matCellDef="let user">
        <span class="text">{{user.firstName}}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>
        <span class=" small light bold">
          {{'USER.EMAIL' | translate}}
        </span>
      </th>
      <td mat-cell *matCellDef="let user">
        <div class="fx-row align-items-center justify-content-start">
          <a [href]="'mailto:'+user.email">{{user.email}}</a>
          <mat-icon class="dark ml-5 clickable" inline fontSet="material-icons-outlined" [cdkMenuTriggerFor]="menu"
            *ngIf="user.invitedBy && user.invitedBy.firstName && user.invitedBy.lastName">info</mat-icon>
          <ng-template #menu>
            <mat-card class="menu-container p-8 elevation" cdkMenu
              *ngIf="user.invitedBy && user.invitedBy.firstName && user.invitedBy.lastName">
              <span class="small dark">{{'USER.INVITED_BY' | translate}}</span>
              <div class="fx-row justify-content-start align-items-center">
                <app-avatar [user]="user.invitedBy" [size]="20"></app-avatar>
                <span class="small ml-5">{{user.invitedBy.firstName}} {{user.invitedBy.lastName}}</span>
              </div>
            </mat-card>
          </ng-template>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="profile">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span class=" small light bold">
          {{'USER.PROFILE' | translate}}
        </span>
      </th>
      <td mat-cell *matCellDef="let user">
        <app-user-profile [role]="user.role"></app-user-profile>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
      </th>
      <td mat-cell *matCellDef="let user">
        <div class="fx-row align-items-center justify-content-end">
          <button mat-icon-button [disabled]='!canDelete(user)' (click)='delete(user)'
            [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="'CASE.REVOKE_USER_ACCESS' | translate">
            <mat-icon [class]="canDelete(user) ? 'red' : 'lighter'" fontSet="material-icons-outlined">delete</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
    </tr>
  </table>
  <div class="p-16" *ngIf="users.totalDocs === 0">
    <span class="text light">{{'ORGANIZATION.SEARCH_NO_USERS' | translate}}</span>
  </div>
  <div class="fx-flex align-items-center justify-content-end">
    <mat-paginator [length]="users.totalDocs || 0" [pageSize]="users.limit || 0"
      [pageIndex]="users.page ? (users.page-1) : 0" [pageSizeOptions]="[10, 25, 50, 100]" (page)="handlePage($event)">
    </mat-paginator>
  </div>
</mat-card>